import castArray from 'lodash/castArray'
import first from 'lodash/first'
import trim from 'lodash/trim'
import { useRouter } from 'next/router'
import React, { FC } from 'react'

import SearchResults from '@Domains/Product/Features/SearchResults'

interface SearchResultsBlockProps {
  id?: string
}

const SearchResultsBlock: FC<SearchResultsBlockProps> = ({ id }) => {
  const { query } = useRouter()

  return (
    <SearchResults id={id} query={trim(first(castArray(query.q)))} />
  )
}

export default SearchResultsBlock
